const UPLOAD_STATUS = {
  INITIAL: 'initial',
  UPLOADING: 'uploading',
  COMPLETE: 'complete',
  ERROR: 'error',
  LOADING: 'loading',
};

const UPLOAD_OPTIONS = {
  container: 'readiness',
  owner: 'srs-lessons',
  isFullContainerName: false,
};

const SERVER_GENERIC_ERROR =
  'Something went wrong with the file upload. Please try again later.';

export { UPLOAD_STATUS, UPLOAD_OPTIONS, SERVER_GENERIC_ERROR };
